import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const MaintenanceContext = createContext({
  enabled: false,
  message: "",
  start_at: null,
  end_at: null,
  loading: true,
  refresh: () => {},
});

export function MaintenanceProvider({ children }) {
  const [state, setState] = useState({
    enabled: false,
    message: "",
    start_at: null,
    end_at: null,
    loading: true,
  });

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/maintenance");
      setState({
        enabled: !!data.enabled,
        message: data.message || "",
        start_at: data.start_at || null,
        end_at: data.end_at || null,
        loading: false,
      });
    } catch (e) {
      // Don't silently swallow — surface to console for observability.
      console.warn("Failed to fetch maintenance status:", e?.message || e);
      setState((s) => ({ ...s, loading: false }));
    }
  }, []);

  useEffect(() => {
    refresh();
    const interval = setInterval(refresh, 30000); // light poll every 30s
    return () => clearInterval(interval);
  }, [refresh]);

  return (
    <MaintenanceContext.Provider value={{ ...state, refresh }}>
      {children}
    </MaintenanceContext.Provider>
  );
}

export const useMaintenance = () => useContext(MaintenanceContext);
